skrilla.controller('salesCtrl', function ($scope, cacheService, modalService) {
    $scope.key = "sales";
    $scope.sales = cacheService.getObjectOrElse("salesTable", []);

    $scope.open = function(sale){
        cacheService.registerObject("saleDetails", sale);
        modalService.openModal("/views/sales/salesModal.html", true, 'lg', true, true);
    }

    $scope.getColour = function(sale){
        switch(sale.status){
            case "DECLINED":
                return "light-red";
            case "APPROVED":
                return "light-blue";
            case "PAID":
                return "light-green";
            default :
                return "";
        }
    }

});